import React, {useEffect, useState} from 'react';
import './Login.css';
import {Button, Row, Typography} from "antd";
import {useTranslation} from "react-i18next";
import {MainImage} from "../../components/image/MainImage";
import {themeLocations} from "../../theme/themeLocations";
import HeaderBanner from "../../components/layout/HeaderBanner";
import MainLayout from "../../components/layout/MainLayout";
import {getSessionData} from "../../utility/global-util";
import {asPortalUrl} from "../../utility/fetch-util";

const { Title } = Typography;


const SSOLogout = () => {

    const { t } = useTranslation();

    const [showButton, setShowButton] = useState(false);

    const onLoginClick = () => {
        let loginUrl = asPortalUrl('');
        loginUrl = loginUrl.replace('/driver', '');  //from bynxFLEET
        loginUrl = loginUrl + '/openid?provider=' + getSessionData('ssoProvider') + '&destination=' + getSessionData('ssoDestination');
        window.location.replace(loginUrl);
        //TODO make openid a variable/parameter if external SSO is supported in future
    }

    useEffect(() => {
        setShowButton(getSessionData('ssoProvider') && getSessionData('ssoDestination'));
    }, []);

    return (
        <MainLayout showHeader={false} showTabMenu={false} showSubHeader={true} startHigher="280px"
                    subHeaderContent={<HeaderBanner/>}>
            <Row type="flex" align="middle" justify="center">
                <div className="login-content">
                    <Row type="flex" justify="center" className="login-logo">
                        <MainImage imageSrc={themeLocations.MAIN_LOGO}/>
                    </Row>
                    <Row className="logoff-text" justify="center" align="middle">
                        <Title level={3}>{t('message.successfully_logged_out')}</Title>
                    </Row>
                    { showButton
                      ? <Row justify="center" align="middle">
                            <Button className="logoff-button" onClick={() => onLoginClick()}>{t('action.login_again')}</Button>
                        </Row>
                      : <p style={{ marginBottom: '30px' }}></p> }
                </div>
            </Row>
        </MainLayout>
    );
}

export default SSOLogout;